// Following constants represent pixel values for DataGrid columns

export const MIN_COLUMN_WIDTH = 20
export const MAX_COLUMN_WIDTH = 200

export const DEFAULT_LABEL_COLUMN_WIDTH = 150
export const MIN_LABEL_COLUMN_WIDTH = 60
export const DEFAULT_METRIC_COLUMN_WIDTH = 50

export const DEFAULT_PADDING = 24
export const DROPDOWN_PADDING_ADJUSTMENT = 70

export const DEFAULT_FONT = "12px Open Sans"
export const GROUP_HEADER_FONT = `700 ${DEFAULT_FONT}`
export const METRIC_HEADER_FONT = "600 10.5px Open Sans"

export const MIN_EXPANDED_COLUMN_WIDTH = 96
export const BUFFER_WIDTH = 1
export const EXTERNAL_ICON_WIDTH = 20
